import { apiFetch } from '@/shared/api/client'
import { isMockApi } from '@/shared/env'

/** Satu baris material pada retur dapur→gudang (mirror kitchen-server WarehouseMaterialReturnLineItem). */
export type ApiWarehouseMaterialReturnLine = {
  id: string
  material_id: string
  material_name: string
  uom: string
  qty_kitchen: number
  qty_warehouse_received?: number
  notes?: string
}

/** Satu retur bahan baku dapur→gudang (mirror kitchen-server WarehouseMaterialReturnItem). */
export type ApiWarehouseMaterialReturn = {
  id: string
  code: string
  warehouse_name: string
  status: string
  notes?: string
  updated_at: string
  published_at?: string
  lines: ApiWarehouseMaterialReturnLine[]
}

export type TodayWarehouseMaterialReturnsResponse = {
  returns: ApiWarehouseMaterialReturn[]
}

export type WarehouseMaterialReturnLineInput = {
  materialId?: string
  materialCode?: string
  qty: number
  uom: string
  notes?: string
}

export type WarehouseMaterialReturnSavePayload = {
  notes?: string
  lines: WarehouseMaterialReturnLineInput[]
}

export type SaveWarehouseMaterialReturnResponse = {
  return_id: string
  return_code: string
  status: string
  updated_at: string
}

export type PublishWarehouseMaterialReturnResponse = {
  return_id: string
  return_code: string
  status: string
  token: string
  payload: string
  expires_at: string
  published_at: string
}

const MOCK_RETURNS: ApiWarehouseMaterialReturn[] = [
  {
    id: 'mock-wmr-1',
    code: 'WMR-MOCK-01',
    warehouse_name: 'Gudang Pusat',
    status: 'draft',
    updated_at: new Date().toISOString(),
    lines: [
      {
        id: 'l1',
        material_id: 'm-tepung',
        material_name: 'Tepung Cakra Kembar',
        uom: 'kg',
        qty_kitchen: 5,
      },
    ],
  },
]

export async function fetchTodayWarehouseMaterialReturns(
  _deviceId: string,
): Promise<TodayWarehouseMaterialReturnsResponse> {
  if (isMockApi) {
    return { returns: MOCK_RETURNS }
  }
  return apiFetch<TodayWarehouseMaterialReturnsResponse>('/kitchen/warehouse-material-returns/today')
}

export async function saveWarehouseMaterialReturn(
  returnRef: string,
  payload: WarehouseMaterialReturnSavePayload,
): Promise<SaveWarehouseMaterialReturnResponse> {
  if (isMockApi) {
    await new Promise((r) => setTimeout(r, 300))
    return {
      return_id: returnRef === 'new' ? 'mock-wmr-new' : returnRef,
      return_code: 'WMR-MOCK-01',
      status: 'draft',
      updated_at: new Date().toISOString(),
    }
  }
  return apiFetch(`/kitchen/warehouse-material-returns/${encodeURIComponent(returnRef)}/save`, {
    method: 'POST',
    body: JSON.stringify({
      notes: payload.notes ?? '',
      lines: payload.lines.map((l) => ({
        material_id: l.materialId ?? '',
        material_code: l.materialCode ?? '',
        qty: l.qty,
        uom: l.uom,
        notes: l.notes ?? '',
      })),
    }),
  })
}

export async function publishWarehouseMaterialReturn(
  returnRef: string,
): Promise<PublishWarehouseMaterialReturnResponse> {
  if (isMockApi) {
    await new Promise((r) => setTimeout(r, 400))
    const id = returnRef === 'new' ? 'mock-wmr-new' : returnRef
    return {
      return_id: id,
      return_code: 'WMR-MOCK-01',
      status: 'ready_for_pickup',
      token: 'mock-token',
      payload: `SUPEROTI:WRH:${id}:mock-token`,
      expires_at: new Date(Date.now() + 15 * 60_000).toISOString(),
      published_at: new Date().toISOString(),
    }
  }
  return apiFetch(`/kitchen/warehouse-material-returns/${encodeURIComponent(returnRef)}/publish`, {
    method: 'POST',
    body: JSON.stringify({}),
  })
}
